module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_styled_01-df23460c8332a658c8ec968beea316ac.png";